import clsx from 'clsx';
import { Children } from 'react';

const BCard = ({
  children,
  bgColor = 'bg-white',
  maxSize,
  className,
  isClickable = false,
  onClick,
  outlineColor = 'outline-white',
}) => {
  const handleOnClick = () => {
    if (!isClickable) return;
    onClick();
  };
  return (
    <div
      onClick={handleOnClick}
      className={clsx(
        bgColor,
        'flex h-fit w-full gap-2.5 rounded-[20px] outline',
        maxSize,
        outlineColor,
        className,
        isClickable ? 'cursor-pointer' : ''
      )}
    >
      <div className="flex w-full flex-col">{children}</div>
    </div>
  );
};
const Header = ({ children, withTitle = false, title, className }) => {
  const childrenArray = Children.toArray(children);

  return (
    <div className={clsx('flex justify-between rounded-t-[20px] p-4', className)}>
      <div className="flex flex-col gap-2">
        {withTitle && <p className="text-xl leading-tight font-semibold text-slate-700">{title}</p>}
        {childrenArray[0]} {/* First child */}
      </div>
      {childrenArray.length > 1 && (
        <div>
          {childrenArray[1]} {/* Second child */}
        </div>
      )}
    </div>
  );
};
const Body = ({ children, withDivider = false }) => {
  return (
    <div className={clsx('flex w-full flex-col gap-2 p-4', withDivider ? 'divide-y divide-slate-200' : '')}>
      {children}
    </div>
  );
};
const Label = ({ children, label }) => {
  return (
    <div className={'flex flex-col gap-4 py-2'}>
      <div className={'block items-center justify-between text-sm leading-tight font-normal sm:flex'}>
        <p className={'text-nowrap text-slate-400'}>{label}</p>
        {children}
      </div>
    </div>
  );
};
BCard.Header = Header;
BCard.Body = Body;
BCard.Label = Label;
export default BCard;
